import { render, staticRenderFns } from "./Parceria_Sindirepa.vue?vue&type=template&id=0ffb1f9d"
import script from "./Parceria_Sindirepa.vue?vue&type=script&lang=js"
export * from "./Parceria_Sindirepa.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Sindirepa.vue?vue&type=style&index=0&id=0ffb1f9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports